<template>
  <el-dialog
    :title="$t('企业联系人列表')"
    :visible.sync="dialogVisible"
    append-to-body
    custom-class="dialog-kf-pc"
  >
    <div class="kf-img-pc" v-if="isEempty">
      <div>
        <span>{{ $t('该企业尚未配置客服，不支持在线沟通~') }}</span>
      </div>
    </div>
    <div class="kf-box-pc" v-else>
      <el-tabs v-model="customerTypeSelect" @tab-click="handleClick">
        <el-tab-pane
          :label="$t('商务代表')"
          name="BUSINESS_REPRESENTATIVE"
        ></el-tab-pane>
        <el-tab-pane
          :label="$t('咨询顾问')"
          name="CUSTOMER_SERVICE"
        ></el-tab-pane>
      </el-tabs>
      <div class="kf-pc-search">
        <el-input v-model="searchVal" :placeholder="$t('请输入条件搜索')" />
        <el-button type="primary" @click="search()">{{ $t('搜索') }}</el-button>
      </div>

      <div class="serchArea">
        <ul v-if="dataShow">
          <li
            v-for="item in searchData"
            :key="item.userDisplay || item.userName"
          >
            <span>{{ item.userDisplay || item.userName }}</span>
            <a @click="jumpChat(item)">
              <b class="icon-chat"></b>{{ $t('立即沟通') }}
            </a>
          </li>
        </ul>
        <ul v-if="dataNotShow">
          <li>{{ $t('暂无联系人') }}</li>
        </ul>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getAccountUserListApi } from '@/api/exhibition'
import getTranslation from '@/locale/getTranslation'
export default {
  data() {
    return {
      accountName: this.$route.query.accountName,
      enterpriseId: this.$route.query.enterpriseId,
      dialogVisible: false,
      customerTypeSelect: 'BUSINESS_REPRESENTATIVE',
      customerType: [
        { code: 'BUSINESS_REPRESENTATIVE', name: getTranslation('商务代表') },
        { code: 'CUSTOMER_SERVICE', name: getTranslation('咨询顾问') }
      ],
      searchVal: '',
      items: [],
      searchData: [],
      customerService: {},
      isEempty: true,
      chatUrl: '#',
      dataShow: false,
      dataNotShow: false
    }
  },
  async created() {
    await this.getCustomServers()
    this.search()
  },
  methods: {
    async handleClick() {
      await this.changeCustomerTypeSelect()
      this.searchVal = ''
      this.search()
    },
    open() {
      this.dialogVisible = true
    },
    async getCustomServers() {
      try {
        let _data = await getAccountUserListApi({
          accountName: this.enterpriseId,
          showAccountInfo: true,
          userImStatus: 'YES',
          pageNumber: 1,
          pageSize: 500
        })
        if (_data.data) {
          this.formatArr(_data.data.records)
        }
      } catch (_err) {
        this.errorHandle(_err)
      }
    },
    formatArr(_serviceArr) {
      if (_serviceArr && _serviceArr.length > 0) {
        _serviceArr.forEach(_server => {
          if (!this.customerService[_server.userDuty])
            this.customerService[_server.userDuty] = []
          this.customerService[_server.userDuty].push(_server)
        })
        this.customerType.forEach(_type => {
          if (
            this.customerService[_type.code] &&
            this.customerService[_type.code].length > 0
          ) {
            this.isEempty = false
          }
        })
        this.changeCustomerTypeSelect()
      }
    },
    changeCustomerTypeSelect() {
      if (this.customerTypeSelect === 'BUSINESS_REPRESENTATIVE') {
        this.items = this.customerService.BUSINESS_REPRESENTATIVE
      } else {
        this.items = this.customerService.CUSTOMER_SERVICE
      }
    },
    errorHandle(_err) {
      if (_err.status == 401 || _err.status == 429) return
      this.$message({
        type: 'error',
        message: _err.message || getTranslation('请求失败，请稍后重试~')
      })
    },
    search() {
      if (this.items) {
        var item = this.items.filter(ele => {
          if (ele.userDisplay) {
            if (ele.userDisplay.match(this.searchVal)) {
              return ele
            }
          } else {
            if (ele.userName.match(this.searchVal)) {
              return ele
            }
          }
        })
        this.searchData = item
        if (this.searchData.length !== 0) {
          this.dataShow = true
          this.dataNotShow = false
        } else {
          this.dataShow = false
          this.dataNotShow = true
        }
      } else {
        this.searchData = []
        this.dataShow = false
        this.dataNotShow = true
      }
    },
    jumpChat(item) {
      console.log(item)
      window.open(
        `https://imchat${process.env.VUE_APP_DOMAIN_SUFFIX}/imchat/#/home/chat?userName=${item.userName}`
      )
    }
  }
}
</script>
<style lang="scss">
.dialog-kf-pc {
  width: 637px;
  max-height: 588px;
  border-radius: 8px;
  .el-dialog__header {
    border-bottom: 1px solid #e4e7ed;
  }
  .el-dialog__body {
    padding: 10px 90px 30px !important;
    .kf-box-pc {
      .el-tabs {
        .el-tabs__nav {
          left: 50%;
          transform: translateX(-50%) !important;
          z-index: 3;
          font-size: 800;
        }
        .el-tabs__nav-wrap::after {
          background-color: white;
        }
        .el-tabs__item.is-active {
          color: #fe8c01;
        }
        .el-tabs__item:hover {
          color: #fe8c01;
        }
        .el-tabs__active-bar {
          background-color: #fe8c01;
        }
      }
      .kf-pc-search {
        .el-input {
          width: 80%;
          vertical-align: top;
          .el-input__inner {
            border-radius: 4px 0 0 4px;
            border-width: 1px 0 1px 1px;
          }
        }
        .el-input__inner:hover,
        .el-input__inner:focus {
          border-color: #fe8c01;
        }
        .el-button {
          width: 20%;
          height: 40px;
          border-radius: 0 4px 4px 0;
          vertical-align: top;
        }
      }
      .serchArea {
        max-height: 398px;
        overflow-y: auto;
        ul {
          margin-top: 6px;
        }
        li {
          height: 56px;
          line-height: 56px;
          a {
            color: #fe8c01;
            float: right;
            margin-right: 5px;
            cursor: pointer;
          }
          .icon-chat {
            display: inline-block;
            width: 14px;
            height: 14px;
            background-image: url('~@/assets/img/chat.png');
            background-repeat: no-repeat;
            background-size: contain;
            vertical-align: middle;
            margin-right: 10px;
          }
        }
      }
      .serchArea::-webkit-scrollbar {
        width: 2px;
        height: 1px;
        margin-right: -10px;
      }
      .serchArea::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background: #e4dede;
      }
      .serchArea::-webkit-scrollbar-track {
        border-radius: 2px;
        background: #ffffff;
      }
    }
    .kf-img-pc {
      margin: 0 auto;
      width: 330px;
      height: 300px;
      background-image: url('~@/assets/img-m/ni-list2.png');
      background-repeat: no-repeat;
      background-size: contain;
      div {
        text-align: center;
        padding-top: 250px;
        word-break: normal;
      }
    }
  }
}
</style>
